export const baseURL = process.env.PUBLIC_URL || '';
export const intercomAppID = 'fsx1yph8';



// WEBPACK FOOTER //
// ./src/config.js